import { Link, useOutletContext } from "react-router-dom";
import { askPreview } from "../components/ChatBubble.tsx";
import { SiteStage } from "../components/SiteStage.tsx";
import { OWN_QUESTIONS, SAMPLE_QUESTIONS } from "../lib/setup.ts";
import type { AgentOutlet } from "./AgentLayout.tsx";

export function TestAgent() {
  const { agent, liveTheme, mark, progress, note } = useOutletContext<AgentOutlet>();
  const questions = agent.isSample ? SAMPLE_QUESTIONS : OWN_QUESTIONS;
  return (
    <div className="stack">
      <header className="step-head">
        <p className="eyebrow">Step 4 of 6</p>
        <h1>Test it</h1>
        <p className="lead">This is the chat your visitors will see. Ask something your files answer. Sources show under the reply.</p>
      </header>
      {!progress.knowledge ? (
        <p className="banner">Add a file first. Until then, the chat can only say it does not know.</p>
      ) : null}
      <div className="suggestions" role="group" aria-label="Suggested questions">
        {questions.map((question) => (
          <button key={question} className="chip" type="button" onClick={() => askPreview(agent.id, question)}>
            {question}
          </button>
        ))}
      </div>
      <SiteStage
        agentId={agent.id}
        name={agent.name}
        theme={liveTheme}
        sample={agent.isSample}
        note={note}
        onAnswered={() => mark("test")}
      />
      {progress.test ? (
        <Link className="button block" to="../look">
          Next: customize the look
        </Link>
      ) : (
        <p className="muted">Send a question to continue. The bubble in the preview is the one to use.</p>
      )}
    </div>
  );
}
